import React, { useState } from 'react';
import { Button } from './ui/button';
import { Phone, Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="/images/logo.jpeg" 
              alt="BS Devis&Plan" 
              className="w-12 h-12 rounded-lg object-cover"
            />
            <div>
              <h1 className="text-xl font-bold text-slate-800">BS Devis&Plan</h1>
              <p className="text-xs text-slate-600">Bureau d'études BTP</p>
            </div>
          </div>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Prestations
            </button>
          </nav>

          {/* CTA Desktop */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="tel:0650242913"
              className="flex items-center space-x-2 text-slate-700 hover:text-blue-600 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">06 50 24 29 13</span>
            </a>
            <Button 
              onClick={() => window.location.href = 'tel:0650242913'}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              Nous appeler
            </Button>
          </div>

          {/* Menu Mobile */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Menu Mobile */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-200">
            <nav className="flex flex-col space-y-4 mt-4">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-left text-slate-700 hover:text-blue-600 font-medium transition-colors"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-left text-slate-700 hover:text-blue-600 font-medium transition-colors"
              >
                Prestations
              </button>
              <div className="pt-4 border-t border-slate-200">
                <a 
                  href="tel:0650242913"
                  className="flex items-center space-x-2 text-slate-700 hover:text-blue-600 transition-colors mb-3"
                >
                  <Phone className="w-4 h-4" />
                  <span className="font-medium">06 50 24 29 13</span>
                </a>
                <Button 
                  onClick={() => window.location.href = 'tel:0650242913'}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Nous appeler
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};